import React from "react";

/**
 * Renders clickable link overlays positioned by percentage rects.
 * links: Array<{ leftPct, topPct, widthPct, heightPct, url, title }>
 */
export default function LinkLayer({ links = [], zoomKey, onAnchorMouseDown }) {
  return (
    <div className="fb-link-layer" key={zoomKey} style={{ position: "absolute", inset: 0, zIndex: 5, pointerEvents: "auto" }}>
      {links.map((lnk, idx) => (
        <a
          key={`${idx}-${zoomKey}`}
          href={lnk.url}
          title={lnk.title || lnk.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "absolute",
            left: `${(lnk.leftPct ?? 0) * 100}%`,
            top: `${(lnk.topPct ?? 0) * 100}%`,
            width: `${(lnk.widthPct ?? 0) * 100}%`,
            height: `${(lnk.heightPct ?? 0) * 100}%`,
            background: "transparent",
            pointerEvents: "auto",
            cursor: "pointer",
          }}
          onMouseDown={onAnchorMouseDown}
          data-nopan="true"
          aria-label={lnk.title || lnk.url}
        />
      ))}
    </div>
  );
}
